import type { Ref } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      settings: {
        general_settings: {
          tabs: {
            affiliate_banner: {
              tab_name: 'TAB_NAME',
              choose_banner: 'CHOOSE_BANNER',
              drop_banner_here: 'DROP_BANNER_HERE',
              resolution_banner: 'RESOLUTION_BANNER',
              invalid_file_format: 'INVALID_FILE_FORMAT',
              invalid_file_size: 'INVALID_FILE_SIZE',
              link: 'LINK',
              enabled: 'ENABLED',
              preview_banner_btn: 'PREVIEW_BANNER_BTN',
            },
          },
        },
      },
    },
  }));
}
